export const startScrollingChat = (milliseconds) => {
  setTimeout(() => {
    const chatBox = document.querySelector('.chat-box');
    if (chatBox) {
      chatBox.scrollTo(0, chatBox.scrollHeight);
    }
  }, milliseconds);
};
